import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";
import { IDriver } from "Types/survey";

export default function useDrivers() {
  const { mode } = useAppSelector((state) => state.fleet);

  const statusQuery = () => {
    return "disabled";
  };
  const nameQuery = () => {
    return " ";
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: ["drivers", mode],
    queryFn: (): Promise<IDriver[]> => {
      return Api.get(`driver?q=${nameQuery()}`, "https://admin-api.behamrah.kashantejarat.ir/api/v1/").then((res) => {
        return res.data.Data.data;
      });
    },
    enabled: mode === "drivers",
  });

  return { data, isLoading, refetch, isFetching };
}
